import React from 'react';
import { IconShieldCheck } from '@tabler/icons-react';
import './SocialProof.css';

// Trust primitive shown on the fix landing page.

export const StatGuarantee = ({ className = '' }) => (
  <div className={`sp-guarantee ${className}`}>
    <IconShieldCheck size={24} />
    <span>We never touch your activities, stats, or PRs. We only fix the map image.</span>
  </div>
);
